import Legal from '@/views/Legal.vue'

export default {
    path: '/legal/*',
    name: 'legal',
    component: Legal
}
